import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { BarChart3, CalendarClock, Columns3, Handshake, Map as MapIcon } from 'lucide-react';
import { useAuth } from '../../hooks/useAuth';
import { confirmDiscard, hasUnsavedChanges } from '../../utils/unsavedChanges';
import SuperAdminShell, { ShellGroup } from '../superadmin/SuperAdminShell';
import SalesWorkspace, { SalesView } from './SalesWorkspace';

/**
 * Πάνελ για τον ρόλο 'sales' (υπάλληλοι HQ, κατάστημα 1 — migration 285): το ίδιο πλαίσιο με τον super admin και
 * τη διαχείριση καταστήματος (κεφαλίδα + πλαϊνό μενού), με μόνη ομάδα τις Πωλήσεις — καμία πρόσβαση σε
 * καταστήματα, παραστατικά ή χρεώσεις.
 */
const PAGES: Record<string, SalesView> = {
  'sales-today': 'today', 'sales-leads': 'list', 'sales-board': 'board', 'sales-map': 'map', 'sales-reports': 'reports',
};

const SalesPanel: React.FC = () => {
  const { t } = useTranslation(['superAdminPanel']);
  const { logout, employee } = useAuth();
  const [active, setActive] = useState('sales-today');

  const handleLogout = async () => {
    if (hasUnsavedChanges() && !confirmDiscard()) return;
    await logout();
    window.location.href = '/login';
  };
  const select = (id: string) => {
    if (id === active || !PAGES[id]) return;
    if (hasUnsavedChanges() && !confirmDiscard()) return;
    setActive(id);
  };

  const groups: ShellGroup[] = [{
    id: 'sales',
    label: t('superAdminPanel:nav.groups.sales'),
    items: [
      { id: 'sales-today', label: t('superAdminPanel:nav.salesToday'), icon: CalendarClock },
      { id: 'sales-leads', label: t('superAdminPanel:nav.salesLeads'), icon: Handshake },
      { id: 'sales-board', label: t('superAdminPanel:nav.salesBoard'), icon: Columns3 },
      { id: 'sales-map', label: t('superAdminPanel:nav.salesMap'), icon: MapIcon },
      { id: 'sales-reports', label: t('superAdminPanel:nav.salesReports'), icon: BarChart3 },
    ],
  }];
  const userName = [employee?.first_name, employee?.last_name].filter(Boolean).join(' ') || employee?.name || '';

  return (
    <SuperAdminShell
      groups={groups}
      activeId={active}
      onSelect={select}
      userName={userName}
      roleLabel={t('superAdminPanel:nav.groups.sales')}
      onLogout={handleLogout}
    >
      <SalesWorkspace key={active} view={PAGES[active]} onShowList={() => setActive('sales-leads')} />
    </SuperAdminShell>
  );
};

export default SalesPanel;
